/**
 * Randomly selects an item from an array based on specified probabilities.
 *
 * @template T - The type of items in the array.
 * @param {T[]} array - The array of items to choose from.
 * @param {number[]} probabilities - An array of probabilities (between 0 and 1) corresponding to each item in the array.
 * @returns {T} - The selected item from the array.
 */

export const getRandomValueWithProbabilities = <T>(
  array: T[],
  probabilities: number[]
) => {
  const randomValue = Math.random()
  let selectedValue = array[0] // Intially select 1st value
  let cumulativeProbability = 0

  for (let i = 0; i < array.length; i++) {
    cumulativeProbability += probabilities[i]

    if (randomValue <= cumulativeProbability) {
      selectedValue = array[i]
      break
    }
  }

  return selectedValue
}
